module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top'), _vm._v(" "), _c('main', {
    staticClass: "container"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bcc4586!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Suggestion.vue
// module id = 70
// module chunks = 0